const getReference = (obj, reference) => {
	let result = obj;
	/*eslint no-useless-escape: "off"*/
	let arrayWithArrayKeys = reference.match(/[^\]\[.]+/g);
	try {
		arrayWithArrayKeys.forEach(key => {
			result = result[key];
		});
		return result;
	} catch (error) {
		return undefined;
	}
};

export default getReference;
